
import React from "react";
import PageTop from "../../ui/page-top";
import { HtmlMarkup } from "../../lib/processHtml";
import useFetchPage from "../../lib/hooks/use-fetch-page";
import { getCurrentUser } from "../../lib/auth_base/localstorage";


export default function AboutDetail() {
  const user =  getCurrentUser();
  const { data:res,loading } = useFetchPage({ slug: "about", endpoint: "fetch_page" });
  const page = res.status
    ? res.data
    : { title: "About HiGorgeous", description: "Error fetching page" };

  return (
    <React.Fragment>
      <PageTop
        is_logged={user ? true : false}
        page={{ title: page?.title, url: "/about", bg_color: "sky" }}
      />
      {loading ? (<div className="page-body"><div className="pane-container py30">
            <div className="half-pane white px20 py20">
      Loading Page...
</div></div></div>
):(<>
      <div className="page-body">
          <div className="pane-container py30">
            <div className="half-pane white px20 py20">
              <HtmlMarkup word={page.description} />
            </div>
          </div>
      </div></>)}
    </React.Fragment>
  );
}
